import React, { useMemo } from 'react'

import { useGetCommissionQuery } from 'products/reduxApi'
import { Col, Row } from 'uiComponents/flex'
import { SingleSelectFieldFormik, SingleSelectOption } from 'uiComponents/input'
import { TextWithHorizontalLine } from 'uiComponents/pageElements'
import { Section } from './common'
import Infotip from 'uiComponents/infotip'
import { useTranslation } from 'translations'

interface Props {
    commissionTooltipText?: string
}

const Commission: React.FC<Props> = ({ commissionTooltipText }) => {
    const { t } = useTranslation()
    const { data } = useGetCommissionQuery({})

    const commissionGroup = useMemo<SingleSelectOption[]>(() => {
        if (!data) {
            return [] as any
        }

        return data?.map((group) => ({ value: group.id, name: group.name }))
    }, [data])

    return (
        <>
            <Section span={12}>
                <TextWithHorizontalLine
                    style={{ marginTop: '0.8em', marginBottom: '1em' }}
                    text={t('products.crud.commission.contractInformation')}
                    alignment="left"
                />
                <Row>
                    <Col span={6} style={{ padding: '0 1em 0 0' }}>
                        <SingleSelectFieldFormik
                            data-testid="commissionId"
                            disabled
                            name="commissionGroupId"
                            withClear
                            label={
                                <>
                                    {t('products.crud.commission.commissionGroup')}
                                    <Infotip maxWidth="300px" pointer="left">
                                        {commissionTooltipText || t('products.crud.commission.commissionGroupTooltip')}
                                    </Infotip>
                                </>
                            }
                            options={commissionGroup}
                        />
                    </Col>
                </Row>
            </Section>
        </>
    )
}

export default Commission
